/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createVendorFromDiscriminatorValue, serializeRemoveVendorImageRequest, serializeVendor, type ErrorResponse, type InternalErrorResponse, type RemoveVendorImageRequest, type Vendor } from '../../../../../models/index.js';
// @ts-ignore
import { MultipartBody, serializeMultipartBody, type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/vendors/{vendorCode}/images/{kind}
 */
export interface WithKindItemRequestBuilder extends BaseRequestBuilder<WithKindItemRequestBuilder> {
    /**
     * Clears the vendor's logo (kind 'logo') or lifestyle shot (kind 'lifestyle') and trashes the stored picture. A picture the vendor has none of is a no-op. The rest of the vendor is left as it is. Agency organizations only.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Vendor>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     delete(body: RemoveVendorImageRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Vendor | undefined>;
    /**
     * Stores a vendor's logo (kind 'logo') or the lifestyle shot that represents the line (kind 'lifestyle') in the platform's image storage and sets it on the vendor: a JPG, PNG, WebP, GIF or SVG of at most 10 MB, sent as multipart/form-data in the 'image' part. Every upload gets a new delivery URL, so nothing keeps showing the old picture from a cache; the picture it replaces is trashed. The rest of the vendor is left as it is. Agency organizations only.
     * @param body A picture for a vendor, sent as multipart/form-data with the file in the image part.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Vendor>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: MultipartBody, requestConfiguration?: RequestConfiguration<WithKindItemRequestBuilderPostQueryParameters> | undefined) : Promise<Vendor | undefined>;
    /**
     * Clears the vendor's logo (kind 'logo') or lifestyle shot (kind 'lifestyle') and trashes the stored picture. A picture the vendor has none of is a no-op. The rest of the vendor is left as it is. Agency organizations only.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(body: RemoveVendorImageRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Stores a vendor's logo (kind 'logo') or the lifestyle shot that represents the line (kind 'lifestyle') in the platform's image storage and sets it on the vendor: a JPG, PNG, WebP, GIF or SVG of at most 10 MB, sent as multipart/form-data in the 'image' part. Every upload gets a new delivery URL, so nothing keeps showing the old picture from a cache; the picture it replaces is trashed. The rest of the vendor is left as it is. Agency organizations only.
     * @param body A picture for a vendor, sent as multipart/form-data with the file in the image part.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: MultipartBody, requestConfiguration?: RequestConfiguration<WithKindItemRequestBuilderPostQueryParameters> | undefined) : RequestInformation;
}
/**
 * Stores a vendor's logo (kind 'logo') or the lifestyle shot that represents the line (kind 'lifestyle') in the platform's image storage and sets it on the vendor: a JPG, PNG, WebP, GIF or SVG of at most 10 MB, sent as multipart/form-data in the 'image' part. Every upload gets a new delivery URL, so nothing keeps showing the old picture from a cache; the picture it replaces is trashed. The rest of the vendor is left as it is. Agency organizations only.
 */
export interface WithKindItemRequestBuilderPostQueryParameters {
    /**
     * Optional: OrganizationId to switch to (must be in the user's OrgCodes).
     */
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const WithKindItemRequestBuilderUriTemplate = "{+baseurl}/api/vendors/{vendorCode}/images/{kind}{?useOrganizationId*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const WithKindItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: WithKindItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createVendorFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeRemoveVendorImageRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
    post: {
        uriTemplate: WithKindItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createVendorFromDiscriminatorValue,
        requestBodyContentType: "multipart/form-data",
        requestBodySerializer: serializeMultipartBody,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
